module.exports = __webpack_public_path__ + "logo.bcd08286ff57ea6ebb9c.png";


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles